// src/hooks/useLanguage.js
// Hook pour utiliser le context de langue - NE PAS MODIFIER

import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from '../context/LanguageContext';

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  const { t } = useTranslation();

  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }

  return {
    ...context,
    t, // Fonction de traduction i18next
  };
};